import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Document from "src/components/Document/Document";
// ----------------------------------------------------------------------

export default function ReviewerDocument() {
  return (
    <>
      <Helmet>
        <title> ReviewerDocument </title>
      </Helmet>

      <Container maxWidth="xl">
        <Document Role="Reviewer" />
      </Container>
    </>
  );
}
